import Button from "./ui/Button";

interface Props {
  returnTo: string;
  disabled?: boolean;
}

export default ({ returnTo, disabled = false }: Props) => {
  const encodedReturnTo = encodeURIComponent(returnTo);

  const startGoogleSignIn = () => {
    window.location.assign(`/api/auth/google/start?returnTo=${encodedReturnTo}`);
  };

  const startMicrosoftSignIn = () => {
    window.location.assign(`/api/auth/microsoft/start?returnTo=${encodedReturnTo}`);
  };

  return (
    <div className="space-y-3">
      <Button
        type="button"
        variant="outline"
        className="h-12 w-full border-slate-300 bg-white text-sm font-semibold text-slate-700"
        onClick={startGoogleSignIn}
        disabled={disabled}
      >
        <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24">
          <path d="M21.805 10.023h-9.623v3.955h5.523c-.238 1.273-.955 2.351-2.029 3.074v2.553h3.289c1.926-1.773 3.04-4.385 3.04-7.48 0-.705-.064-1.383-.2-2.102Z" fill="#4285F4" />
          <path d="M12.182 22c2.756 0 5.068-.914 6.756-2.473l-3.289-2.553c-.913.613-2.08.975-3.467.975-2.654 0-4.903-1.793-5.708-4.202H3.074v2.633A10.2 10.2 0 0 0 12.182 22Z" fill="#34A853" />
          <path d="M6.474 13.747a6.132 6.132 0 0 1 0-3.894V7.22H3.074a10.2 10.2 0 0 0 0 9.16l3.4-2.633Z" fill="#FBBC04" />
          <path d="M12.182 6.051c1.498 0 2.84.516 3.9 1.529l2.92-2.92C17.245 2.92 14.934 2 12.182 2A10.2 10.2 0 0 0 3.074 7.22l3.4 2.633c.801-2.412 3.054-4.202 5.708-4.202Z" fill="#EA4335" />
        </svg>
        Continue with Google
      </Button>

      <Button
        type="button"
        variant="primary"
        className="h-12 w-full bg-[#2F6FED] text-sm font-semibold text-white hover:bg-[#2962d6]"
        onClick={startMicrosoftSignIn}
        disabled={disabled}
      >
        <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 21 21">
          <rect x="1" y="1" width="9" height="9" fill="#F25022" />
          <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
          <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
          <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
        </svg>
        Continue with Microsoft 365
      </Button>
    </div>
  );
};
